import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { CompassButtonModule } from '@pwc/compass/button';
import { CompassIconModule } from '@pwc/compass/icon';

@Component({
  selector: 'esp-save-as-draft',
  imports: [CommonModule, CompassButtonModule, CompassIconModule],
  template: `
    <button
      mat-button
      compass-button
      fullWidth
      type="button"
      class="esp-save-as-draft"
      [disabled]="isDisabled()"
    >
      <mat-icon compassIcon="draft"></mat-icon>
      Save Progress
    </button>
  `,
  styles: `
    .esp-save-as-draft {
      margin-top: 16px;

      &[disabled] {
        pointer-events: none;
      }
    }

    :host:has(.esp-save-as-draft[disabled]) {
      pointer-events: none;
    }
  `,
})
export class SaveAsDraftComponent {
  isDisabled = input(false);
}
